// @flow

import { getCurrentFeatures } from '@tectonics/prs/payment-spec';
import { type UserInputValidationError, type UserInputValidatorArgs, onlyWhenSupport, VALID } from '@tectonics/prs/validation';

export function validator({
  prsSupport,
  spec,
  userInputName,
  userInputValue,
  userInputValues,
}: UserInputValidatorArgs): ?UserInputValidationError {
  const currentFeatures = getCurrentFeatures(spec, userInputValues['selectedPaymentMethod']);
  const onlyWhen = onlyWhenSupport(currentFeatures, prsSupport);

  if (userInputName === 'selectedCryptocurrency') {
    return onlyWhen('display_cryptocurrency_accepts_brand') && validateCryptocurrency(userInputValue);
  }

  if (userInputName === 'selectedProtocol') {
    return onlyWhen('display_cryptocurrency_accepts_brand') && validateProtocol(userInputValue);
  }

  return VALID;
}

function validateCryptocurrency(cryptocurrencyCode?: string): ?UserInputValidationError {
  if (!cryptocurrencyCode || cryptocurrencyCode.trim() === '') {
    return { id: 'empty' };
  }

  return VALID;
}

function validateProtocol(protocolCode?: string): ?UserInputValidationError {
  if (!protocolCode || protocolCode.trim() === '') {
    return { id: 'empty' };
  }

  return VALID;
}
